import React, { useState } from "react";
import Header from "../../components/Header/Header";
import Search from "../../components/CustSearch/Search";
import Arntable from "./arntable";
import parimg from "../../assets/images/parent_arn_icon.png";
import ArnModal from "./arnmodel";
import ArnSearch from "./Arnenrsearch";
import Psfaccordian from "../../components/ChildData/Psfaccordian";
import WaterMark from "../../components/WaterMark";

const Arnenindex = () => {

    return (
        <div>
            <WaterMark />
            <Header heading={"ARN Enrichment"} />

            <div className="min-h-screen bg-gray-100">
                <div className="mt-2 m-3">

                </div>
                <div className={`bg-white shadow-sm border-b`}>
                    <ArnSearch />
                </div>

            </div>        </div>

    );
};

export default Arnenindex;